import React, { useState } from 'react';
import { useModal } from '../ModalContext';
import styled, { useTheme } from 'styled-components';
import { BodyLarge, Heading3Text } from '../../Texts';
import Button from '../../Button';
import axios from 'axios';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';

const ModalContainer = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 545px;
  max-width: calc(100vw - 30px);
  height: fit-content;
  padding: 50px 40px 40px 40px;
  background-color: white;
  border-radius: 16px;
  position: relative;
  @media ${PHONE_MEDIA_QUERY} {
    padding: 30px 24px 24px 24px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 48px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 16px;
  border: 0px solid transparent;
  background-color: ${({ theme }) => theme.background.light};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column-reverse;
  }
`;

const IconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

const Modal: React.FC = () => {
  const { isModalOpen, toggleModal } = useModal();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const emailAlreadySent = localStorage.getItem('email');
  if (!isModalOpen) return null;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const theme = useTheme();
  function isValidEmail(email: string): boolean {
    return emailRegex.test(email);
  }

  return (
    <ModalContainer>
      <Container onClick={toggleModal}>
        <IconContainer>
          <Icon src='/close.webp' />
        </IconContainer>
        {emailAlreadySent ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 15,
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <img src='/email.webp' />
            <Heading3Text>
              Thank you for{' '}
              <span style={{ color: theme.primary.primary }}>joining! </span>
            </Heading3Text>
            <BodyLarge>
              Check you email for further updated. See you soon!
            </BodyLarge>
          </div>
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: 15,
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <img src='/email.webp' />
              <Heading3Text>
                <span style={{ color: theme.primary.primary }}>Join</span> Our
                Mailing List
              </Heading3Text>
              <BodyLarge>
                Be the first to know about our launch and exclusive updates.
                Join our mailing list for early access and special offers.
              </BodyLarge>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 20,
                paddingTop: 30,
              }}
            >
              <StyledInput
                placeholder='Your email address'
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <ButtonContainer>
                <Button
                  fullWidth
                  variant='secondary'
                  onClick={() => toggleModal()}
                >
                  Cancel
                </Button>
                <Button
                  loading={loading}
                  fullWidth
                  disabled={!isValidEmail(email)}
                  onClick={async () => {
                    setLoading(true);
                    try {
                      await axios.post(
                        `https://j5bzz4g4b7.execute-api.us-east-1.amazonaws.com/api/emails`,
                        {
                          email,
                        },
                      );
                      localStorage.setItem('email', email);
                      toggleModal();
                    } catch {
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  SUBMIT
                </Button>
              </ButtonContainer>
            </div>
          </>
        )}
      </Container>
    </ModalContainer>
  );
};

export default Modal;
